"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.global = void 0;

var _fontDefinitions = _interopRequireDefault(require("./fontDefinitions"));

var _colors = require("./variables/colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var global = "\n  " + _fontDefinitions.default + "\n\n  * {\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    margin: 0;\n    padding: 0;\n    outline: none;\n  }\n\n  html,\n  body {\n    min-height: 100vh;\n  }\n\n  html {\n    box-sizing: border-box;\n  }\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  * :focus {\n    outline: 1px dotted " + _colors.colors['slate-grey'] + ";\n    outline-offset: 1px;\n    z-index: 1;\n  }\n\n  * :focus-visible {\n    outline: 2px solid " + _colors.colors.black + ";\n    outline-offset: 2px;\n    z-index: 1;\n  }\n\n  * input:focus, * input:focus-visible {\n    outline: 1px solid " + _colors.colors.black + ";\n    outline-offset: 0;\n    z-index: 1;\n  }\n\n  * a:active:focus,\n  * button:active:focus {\n    outline: none;\n  }\n";
exports.global = global;